<template>
    <multiselect :value="country"
        :options="countriesFormattedList"
        :disabled="disabled"
        :allow-empty="false"
        :show-labels="false"
        track-by="name"
        label="name"
        :placeholder="placeholder"
        :class="['label__input', { 'label__input--active': country }]"
        @search-change="onSearchChange"
        @input="onCountryChanged"
    >
        <span slot="noResult">{{ $t('registerMobileNumber.noResultsCountries') }}</span>
    </multiselect>
</template>

<script>
// Store
import {
    mapGetters,
} from 'vuex';

export default {
    name: 'country-dropdown',
    props: {
        country: {
            type: Object,
            default: null,
        },
        disabled: {
            type: Boolean,
            default: false,
        },
        placeholder: {
            type: String,
            required: true,
        },
    },

    data() {
        return {
            filteredCountries: [],
        };
    },

    computed: {
        ...mapGetters('countries', ['countriesList']),

        countriesFormattedList() {
            return [...this.filteredCountries]
                .map((country) => ({
                    name: country.display,
                    iso2: country.iso2,
                    id: country.id,
                }));
        },
    },

    created() {
        this.filteredCountries = [...this.countriesList];
    },

    methods: {
        onCountryChanged(country) {
            this.$emit('update:country', country);
        },

        onSearchChange(searchParam) {
            if (!searchParam) {
                this.filteredCountries = [...this.countriesList];

                return;
            }

            this.filteredCountries = this.countriesList
                .filter((country) => country.display.toLowerCase().startsWith(searchParam.toLowerCase()));
        },
    },
};
</script>